const state = {
  all: []
}

const mutations = {
  updateControladoresList (state, res) {
    state.all = res.data
  }
}

const actions = {
  listControladores(context) {
    window.axios.get('/api/v2/' + window.localStorage.getItem('projeto') + '/controladores').then((res) => {
      context.commit('updateControladoresList', res)
    })
  },
  updateControlador (context, data) {
    var id = data.id
    let qs = require('querystring')
    console.log(data)
    var dados = qs.stringify(data.controlador)
    return window.axios.put('/api/v2/' + window.localStorage.getItem('projeto') + '/controladores/' + id, dados).then((res) => {
      return res
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Controladores.js